import SDIcon from './SDIcon'

const IconCarbonMobile = (props) => (
  <SDIcon {...props}>
    <title>mobile</title>
    <path d='M22,4H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2H22a2.0027,2.0027,0,0,0,2-2V6A2.0023,2.0023,0,0,0,22,4Zm0,2,0,2H10V6ZM10,28V10H22l0,18Z' />
  </SDIcon>
)

export default IconCarbonMobile
